import z from 'zod'

import { filterSchema } from '@/shared/components/filter/validation'

export const scenarioBusinessSchema = z.record(z.string(), z.any())
export const scenarioStopListSchema = z.object({
	custom_rules: z.array(filterSchema),
	default_rules: z.record(z.string(), z.any()),
})
export const scenarioStrategySchema = z.object({
	demand_strategy: z.object({
		protect: z.string(),
		target: z.string(),
	}),
	markdown_strategy: z.object({
		target: z.string(),
	}),
})

export const scenarioSettingsSchema = z.object({
	stop_list: scenarioStopListSchema,
	business: scenarioBusinessSchema,
	strategy: scenarioStrategySchema,
})
export const scenarioSchema = z.object({
	name: z.string().min(1),
	description: z.string().min(1),
	settings: scenarioSettingsSchema,
})
